import React from 'react'
import { Stack, type StackProps } from '@mantine/core'

export type AppStackProps = StackProps;

/**
 * Standard vertical layout stack with consistent spacing.
 * Default spacing: sm (8px), override with: xs=4px, sm=8px, md=16px, lg=24px, xl=40px
 * Common overrides: spacing="md" for content sections, spacing="xs" for tight groups
 */
export default function AppStack ({ spacing = 'sm', ...props }: AppStackProps) {
  return <Stack spacing={spacing} {...props} />
}
